<template>
  <div class="mt-1" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'CONREGCOL',
            label: 'Report controllo registrazioni',
            formats: ['csv', 'pdf'],
          },
          {
            code: 'RENCOLLAB',
            label: 'Rendiconto singola collaborazione',
            formats: ['pdf'],
            // usare extra solo per variabili particolari, non per beForm:
            // se ne occupa ExportOptions.fetchForm, nei casi in cui serve.
            // extra: {
            //   beFormCreate: beFormCreate,
            //   beRulesCreate: beFormCreate,
            // },
          },
        ]"
      ></export-options>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="book_date"
                label="Data Registrazione Dal"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="book_date"
                label="Data Registrazione al"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="cooperators"
                label="Collaborazioni"
                v-model="filter.byBrokerEnhanced.cooperators"
                :options="cooperators"
                :taggable="true"
                :multiple="true"
                :closeOnSelect="false"
              />
              <b-button
                :pressed.sync="myToggle"
                variant="light"
                class="my-2 btn--smaller btn--x-smaller btn--transparent"
                @click="
                  myToggle ? selectAllCooperators() : deselectAllCooperators()
                "
                >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
              </b-button>
            </div>
            <h3
              v-show="customFilters.length > 0"
              class="inner-filter-title mt-5"
            >
              Filtri aggiuntivi
            </h3>
            <div v-show="customFilters.length > 0">
              <p>Attributi personalizzati</p>

              <b-row v-for="(element, index) in customFilters" :key="index">
                <custom-filter
                  v-model="filter.byAttribute[element.key]"
                  :element="element"
                />
              </b-row>
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <!-- REVIEW story-36-a: enable this when BE can handle sort requests!!! -->
      <!-- sortField="book_date" -->
      <book-entries
        @edit="onEdit"
        @destroy="onDestroy"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterOn="{
          byRelations: [
            'byBroker',
            'byDocument',
            'byTask',
            'byRegistry',
            'byInsurer',
            'byInsuranceAncillary',
            'byVariousAccounting',
            'byInsurerAccounting',
            'byBookTag',
          ],
        }"
        :filterName="filterName"
        :ref="tableRef"
        :hasChecksButtonGroup="false"
        noActions
        sortField="book_date"
      ></book-entries>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BookEntries from "@/components/tables/BookEntries";
// import ButtonGroupTable from "@/components/ButtonGroupTable";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData } from "@/utils/transforms";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
// import ReportsMixin from "@/mixins/ReportsMixin";
// import submitReportModal from "@/components/modals/submitReportModal";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      myToggle: false,
      filter: this.initFilter(),
      filterName: "filterBookEntryCooperator",
      resource: "book_entries",
      repository: "book_entry",
      tableRef: "BookEntryCooperatorTableRef",
      cooperators: [],
      activeFilters: {},
      performedSearch: false,
      fields: [
        {
          key: "cooperator",
          label: this.getDictionary("cooperator"),
          // sortable: true,
          // sortKey: "byBroker.BUID",
        },

        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          formatter: (value) => toLocaleDate(value),
          sortKey: "book_date",
        },
        {
          key: "document_code",
          label: this.getDictionary("code", "book_tag"),
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
          sortable: false,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "customer",
          label: this.getDictionary("registry", "book_entry"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "product",
          label: this.getDictionary("insurance_risk"),
          sortable: true,
          sortKey: "byInsuranceRisk.title",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "take",
          label: this.getDictionary("take", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-center",
        },
        {
          key: "net",
          label: this.getDictionary("net", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
          sortable: true,
        },
        {
          key: "tax",
          label: this.getDictionary("tax", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
          sortable: true,
        },
        {
          key: "agency_gross",
          label: this.getDictionary("agency_gross"),
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    BookEntries,
    CustomFilter,
    // submitReportModal,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    toInfoData,
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    initFilter() {
      let init = {
        byCalendar: {
          from: null,
          to: null,
        },
        byBrokerEnhanced: {
          cooperators: [],
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${item.id}`, item: item, mode: "I" },
      });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // Select at least one cooperator
      if (!this.filter.byBrokerEnhanced.cooperators?.length) {
        this.$showSnackbar({
          preset: "error",
          text: `Devi selezionare almeno un collaboratore`,
        });
        return;
      }
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      // quicksearch
      criteria = {};
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.myToggle = false;
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
    },
    selectAllCooperators() {
      this.filter.byBrokerEnhanced.cooperators = this.getCooperators().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllCooperators() {
      this.filter.byBrokerEnhanced.cooperators = [];
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      getCooperators: "cooperators",
    }),
  },
  beforeMount() {
    /* */
    console.log("beforeMount index");
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("cooperators"))
      resources.push(
        this.$store
          .dispatch(`${path}cooperators`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.cooperators = this.getCooperators();
          this.filter.byBrokerEnhanced.cooperators = this.getCooperators().map(
            (cooperator) => cooperator.value,
          );
          this.myToggle = true;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.cooperators = this.getCooperators();
      this.filter.byBrokerEnhanced.cooperators = this.getCooperators().map(
        (cooperator) => cooperator.value,
      );
      this.myToggle = true;
      this.isLoading = false;
    }
    /* */
  },
};
</script>
